import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";
import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";

export const initialPaypalReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const paypalSlice = createSlice({
    name: "PayPal",
    initialState: { ...initialPaypalReducer },
    reducers: {
        ...integrationReducerActions,

        uploadDataFileRequest(state) {
            state.submitted = true;
            state.isImportLoading = true;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
        },
        uploadDataFileSuccess(state, action) {
            state.configuration = action.payload;
            state.editConfiguration = action.payload;
            state.isImportLoading = false;
            state.imported = true;
            state.importSuccessMessage = "Der Import wurde erfolgreich gestartet";
        },
        uploadDataFileFailure(state, action) {
            state.isImportLoading = false;
            state.imported = false;
            state.importErrorMessage = action.payload;
        },
    },
});

export default paypalSlice;
